import { Layer, VectorLayerDMTR } from './layer';
import Style from 'ol/style/Style';
import VectorSource from 'ol/source/Vector';
import Icon from 'ol/style/Icon';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import CircleStyle from 'ol/style/Circle';
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import {Circle} from "ol/style";

import * as olExtent from 'ol/extent';
import {GritFeature} from "../../models/grit/grit.feature";
import {DeviceModel, InterferenceTestDeviceModel} from "../../models/grit/grit.device-model";

export const StaticLayers: Layer[] = [
  {id:'dummy1', name:'Dummy', image:'navaid.svg', visible:false, olLayer:null},
  {id:'dummy2', name:'Dummy', image:'navaid.svg', visible:false, olLayer:null}];

export const Navaids: Layer[] = [
  {id:'dme', name:'DME', image:'navaid_DME-gray.svg', visible:true ,olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.15,
        color: 'black',
        src: "/assets/img/navaid_DME-white.png",
      }),
    }),
    styleSelected:new Style({
      image: new Icon({
        scale: 0.15,
        src: "/assets/img/navaid_DME_BL.png",
      }),
    }),
  })},
  {id:'vor_dme', name:'VOR/DME', image:'navaid_VOR_DME-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.15,
        color: 'black',
        src: "/assets/img/navaid_VOR_DME-white.png",
      }),
    }),
    styleSelected:new Style({
      image: new Icon({
        scale: 0.15,
        src: "/assets/img/navaid_VOR_DME_BL.png",
      }),
    }),
  })},
  {id:'tacan', name:'TACAN', image:'navaid_TACAN-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.15,
        color: 'black',
        src: "/assets/img/navaid_TACAN-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.15,
        src: "/assets/img/navaid_TACAN_BL.png",
      }),
    }),
  })},
  {id:'vortac', name:'VORTAC', image:'navaid_VORTAC-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.15,
        color: 'black',
        src: "/assets/img/navaid_VORTAC-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.15,
        src: "/assets/img/navaid_VORTAC_BL.png",
      }),
    }),
  })},
  {id:'dme_ils', name:'DME (ILS)', image:'navaid_DME_ILS-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.15,
        color: 'black',
        src: "/assets/img/navaid_DME_ILS-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.15,
        src: "/assets/img/navaid_DME_ILS_BL.png",
      }),
    }),
  })},
  {id:'ndb', name:'NDB', image:'navaid_NDB-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.17,
        color: 'black',
        src: "/assets/img/navaid_NDB-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.17,
        src: "/assets/img/navaid_NDB_BL.png",
      }),
    }),
  })},
  {id:'vor', name:'VOR', image:'navaid_VOR-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.21,
        color: 'black',
        src: "/assets/img/navaid_VOR-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.21,
        src: "/assets/img/navaid_VOR_BL.png",
      }),
    })
  })}
];

export const NavaidTextStyle: Text = new Text({
  font:  '13px Calibri,sans-serif',
  offsetX: 0,
  offsetY: -14,
  overflow: false,
  fill: new Fill({
    color: 'black',
  }),
});

export const AirSpaceBoundary: Layer[] = [
  {
    id:'Air_Space_Boundary', name: 'Air Space Boundary', image:'airspaceboundaries.svg', visible: true,
      olLayer: new VectorLayerDMTR({
        source: new VectorSource(),
        style: new Style({
          fill: new Fill({ color: '#ff0000'}),
          stroke: new Stroke({ color: '#ff0000', width: 2 })
        }),
        styleSelected: new Style({
          fill: new Fill({ color: '#ffea00'}),
          stroke: new Stroke({ color: '#ffea00', width: 2 })
        }),
      })
  }
];
export const SAAMTrafficDensityLayer: Layer[] = [
  {
    id: 'SAAM_Traffic_Layer', name: 'SAAM Traffic', image: 'saam.svg',visible: true,
    olLayer: new VectorLayerDMTR({
      source: new VectorSource(),
      styleSelected: new Style({
        fill: new Fill({ color: 'yellow'}),
        stroke: new Stroke({ color: 'black', width: 1 })
      }),
    }),

  }
]
export const FlightInspectionLayer: Layer[] = [
  {
    id: 'Flight_Inspection_Layer', name: 'Flight Inspection', image: 'saam.svg',visible: true,
    olLayer: new VectorLayerDMTR({
      source: new VectorSource(),
      styleSelected:new Style({
        image: new CircleStyle({
          radius: 1,
          fill: new Fill({color: 'yellow'}),
        })
      })
    }),
  }
];
export const ProcessingToolLayer: Layer[] = [
  {
    id: 'Processing_Tool_Layer', name: 'Processing Tool', image: 'saam.svg',visible: true,
    olLayer: new VectorLayerDMTR({
      source: new VectorSource(),
      styleSelected:new Style({
        image: new CircleStyle({
          radius: 1,
          fill: new Fill({color: 'yellow'}),
        })
      })
    }),
  }
];
export const Trajectory: Layer[] = [
  {
    id:'Trajectory', name: 'Trajectory', image:'SID-red.svg', visible: true,
      olLayer: new VectorLayerDMTR({
        source: new VectorSource(),
        style: new Style({
          fill: new Fill({ color: '#ff0000'}),
          stroke: new Stroke({ color: '#ff0000', width: 2 })
        }),
        styleSelected: new Style({
          fill: new Fill({ color: '#ffea00'}),
          stroke: new Stroke({ color: '#ffea00', width: 2 })
        }),
      })
  }
];

export const Procedures: Layer[] = [
  {id:'sid', name:'SID', image:'SID-red.svg', visible:true ,olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
        fill: new Fill({ color: '#ff0000'}),
        stroke: new Stroke({ color: '#ff0000', width: 2 })
    }),
    styleSelected:new Style({
      fill: new Fill({ color: '#ffea00'}),
      stroke: new Stroke({ color: '#ffea00', width: 2 })
    }),
  })},

  {id:'star', name:'STAR', image:'SID-green.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      fill: new Fill({ color: '#00FF00'}),
      stroke: new Stroke({ color: '#00FF00', width: 2 })
    }),
    styleSelected:new Style({
      fill: new Fill({ color: '#ffea00'}),
      stroke: new Stroke({ color: '#ffea00', width: 2 })
    }),
  })},

  {id:'enroute', name:'ENROUTE', image:'SID-darkblue.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      fill: new Fill({ color: '#0000ff'}),
      stroke: new Stroke({ color: '#0000ff', width: 2 })
    }),
    styleSelected: new Style({
      fill: new Fill({ color: '#ffea00'}),
      stroke: new Stroke({ color: '#ffea00', width: 2 })
    }),
  })},

  {id:'assessment', name:'ASSESSMENT', image:'SID-darkblue.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      fill: new Fill({ color: '#338AFF'}),
      stroke: new Stroke({ color: '#338AFF', width: 1 })
    }),
    styleSelected: new Style({
      fill: new Fill({ color: '#ffea33'}),
      stroke: new Stroke({ color: '#ffea33', width: 2 })
    }),
  })},

  {id:'assessmentoffset', name:'ASSESSMENToffset', image:'SID-darkblue.svg', visible:true, olLayer:new VectorLayerDMTR({
    source: new VectorSource(),
    style: new Style({
      fill: new Fill({ color: '#F0F0F0'}),
      stroke: new Stroke({ color: '#00FFFF', width: 1 })
    }),
    styleSelected: new Style({
      fill: new Fill({ color: '#F0F0F0'}),
      stroke: new Stroke({ color: '#00FFFF', width: 2 })
    }),
  })},

];

export const ProcedureAnalysisTool: Layer[] = [
  {
    id:'Procedure_Analysis_Layer', name: 'Procedure Analysis Layer', image:'', visible: true,
      olLayer: new VectorLayerDMTR({
        source: new VectorSource(),
        style: new Style({
          stroke: new Stroke({ color: 'green', width: 1.5 })
        }),
        styleSelected: new Style({
          stroke: new Stroke({ color: 'green', width: 1.5 })
        }),
      })
  }
];

export const CoordinatePoints: Layer[] = [
  {id:'waypoint', name:'Waypoints', image:'cp4-gray.svg', visible:false, olLayer:new VectorLayerDMTR({
    //minZoom: 7,
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.2,
        color: 'black',
        src: "/assets/img/cp4-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.2,
        color: 'red',
        src: "/assets/img/cp4-white.png",
      }),
    }),
  })},
  {id:'arp_civil', name:'ARP Civil', image:'civil-black.svg', visible:false, olLayer:new VectorLayerDMTR({
  //minZoom: 7,
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.35,
        color: 'black',
        src: "/assets/img/civil-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.35,
        color: 'red',
        src: "/assets/img/civil-white.png",
      }),
    }),
  })},
  {id:'arp_militar', name:'ARP Military', image:'military-black.svg', visible:false, olLayer:new VectorLayerDMTR({
    //minZoom: 7,
      source: new VectorSource(),
      style: new Style({
        image: new Icon({
          scale: 0.35,
          color: 'black',
          src: "/assets/img/military-white.png",
        }),
      }),
      styleSelected: new Style({
        image: new Icon({
          scale: 0.35,
          color: 'red',
          src: "/assets/img/military-white.png",
        }),
      }),
  })},
  {id:'arp_mixed', name:'ARP Mixed', image:'mixed-black.svg', visible:false, olLayer:new VectorLayerDMTR({
    //minZoom: 7,
      source: new VectorSource(),
      style: new Style({
        image: new Icon({
          scale: 0.35,
          color: 'black',
          src: "/assets/img/mixed-white.png",
        }),
      }),
      styleSelected: new Style({
        image: new Icon({
          scale: 0.35,
          color: 'red',
          src: "/assets/img/mixed-white.png",
        }),
      }),
  })},
  {id:'rwy_thr', name:'RWY THR', image:'cp2-gray.svg', visible:false, olLayer:new VectorLayerDMTR({
  //minZoom: 7,
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.35,
        color: 'black',
        src: "/assets/img/cp2-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.35,
        color: 'red',
        src: "/assets/img/cp2-white.png",
      }),
    }),
  })},
  {id:'airspace_vertex', name:'Airspace Vertex', image:'cp1-gray.svg', visible:false, olLayer:new VectorLayerDMTR({
  //minZoom: 7,

    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.2,
        color: 'black',
        src: "/assets/img/cp1-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.2,
        color: 'red',
        src: "/assets/img/cp1-white.png",
      }),
    }),
  })},
  {id:'fix_point', name:'Fix Points', image:'cp3-gray.svg', visible:false, olLayer:new VectorLayerDMTR({
  //minZoom: 7,
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        scale: 0.2,
        color: 'black',
        src: "/assets/img/cp3-white.png",
      }),
    }),
    styleSelected: new Style({
      image: new Icon({
        scale: 0.2,
        color: 'red',
        src: "/assets/img/cp3-white.png",
      }),
    }),

  })},
];
export const coordinatePointsSelectedLayer : Layer = {id:'coordinatePointsSelected', name:'coordinatePointsSelected', image:'cp4-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
  //minZoom: 7,
    source: new VectorSource(),
})}

export const mapSearchHighlightLayer: Layer = {
  id: 'mapSearchHighlight',
  name: 'mapSearchHighlight',
  visible: true,
  image: '',
  olLayer: new VectorLayerDMTR({
    source: new VectorSource(),
  }),
};

export const AzimuthTool: Layer[] = [
  {
    id:'Azimuth_Tool_Layer', name: 'Azimuth Tool Layer', image:'', visible: true,
      olLayer: new VectorLayerDMTR({
        source: new VectorSource(),
        style: new Style({
          fill: new Fill({ color: '#000'}),
          stroke: new Stroke({ color: '#000', width: 2 })
        }),
        styleSelected: new Style({
          fill: new Fill({ color: '#000'}),
          stroke: new Stroke({ color: '#000', width: 2 })
        }),
      })
  }
];

export const RangeRingTool: Layer[] = [
  {
    id:'Range_Ring_Tool_Layer', name: 'Range Ring Tool Layer', image:'', visible: true,
      olLayer: new VectorLayerDMTR({
        source: new VectorSource(),
        style: new Style({
          fill: new Fill({
              color: 'rgb(20, 100, 240)'
          }),
          stroke: new Stroke({
              width: 3,
              color: 'rgb(20, 100, 240)'
          }),
          image: new Circle({
              fill: new Fill({
                color: 'rgb(20, 100, 240)'
              }),
              stroke: new Stroke({
                  width: 10,
                  color: 'rgb(20, 100, 240)'
              }),
              radius: 7
          }),
      }),
      })
  }
];

export const HorizonTool: Layer[] = [
  {
    id:'Horizon_Tool_Layer', name: 'Horizon Tool Layer', image:'', visible: true,
      olLayer: new VectorLayerDMTR({
        source: new VectorSource(),
        style: new Style({
          stroke: new Stroke({ color: 'green', width: 1.5 })
        }),
        styleSelected: new Style({
          stroke: new Stroke({ color: 'green', width: 1.5 })
        }),
      })
  }
];

export const CrossSection: Layer[] = [
  {
    id: 'Cross_Section_Layer', name: 'Cross Section Layer', image: '', visible: true,
    olLayer: new VectorLayerDMTR({
      source: new VectorSource(),
      style: new Style({
        stroke: new Stroke({ color: 'rgb(55, 126, 184)', width: 1.5 }),
      }),
    })
  }
];

export const ProcedureGraph: Layer[] = [
  {
    id:'Procedure_Graph_Layer', name: 'Procedure Graph Layer', image:'', visible: true,
      olLayer: new VectorLayerDMTR({
        source: new VectorSource()
      })
  }
]

export const dbBoundary: Layer[] = [
  {
    id:'8db_boundary_layer', name: '8db Boundary Layer', image:'', visible: true,
    olLayer: new VectorLayerDMTR({
      source: new VectorSource(),
      style: new Style({
        stroke: new Stroke({ color: 'blue', width: 1.5 })
      }),
      styleSelected: new Style({
        stroke: new Stroke({ color: 'blue', width: 1.5 })
      }),
    })
  }
]

//#region GRIT
export const Devices: Layer[] = [
  { id:'jammer',
    name:'Jammer',
    image:"/assets/img/grit/device/jammer.svg", //TODO Change Device SVG
    visible:true ,
    olLayer:new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: GritFeature<InterferenceTestDeviceModel>, resolution) {
        let icon = new Style({
          image: new Icon({scale: 0.2, color: 'black', src: "/assets/img/grit/device/jammer.svg",}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });

        let stroke = new Style({
          stroke: new Stroke({ color: [0,0,0, 0.1], width: 2 }),
          fill: new Fill({color:[0,0,0, 0.1] }),
          geometry: feature.entity.maskGeometry,
        });
        return [icon, stroke];
      },

      styleSelected:function (feature: GritFeature<InterferenceTestDeviceModel>, resolution) {
        let icon = new Style({
          image: new Icon({scale: 0.2, color: 'blue', src: "/assets/img/grit/device/jammer.svg",}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });

        let stroke = new Style({
          stroke: new Stroke({ color: [0,0,255, 0.1], width: 2 }),
          fill: new Fill({color:[0,0,255, 0.1] }),
          geometry: feature.entity.maskGeometry,
        });
        return [icon, stroke];
      },
    })
  },
  { id:'spoofer',
    name:'Spoofer',
    image:"/assets/img/grit/device/spoofer.svg", //TODO Change Device SVG
    visible:true ,
    olLayer:new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: GritFeature<InterferenceTestDeviceModel>, resolution) {
        let icon = new Style({
          image: new Icon({scale: 0.2, color: 'black', src: "/assets/img/grit/device/spoofer.svg",}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });

        let stroke = new Style({
          stroke: new Stroke({ color: [0,0,0, 0.1], width: 2 }),
          fill: new Fill({color:[0,0,0, 0.1] }),
          geometry: feature.entity.maskGeometry,
        });
        return [icon, stroke];
      },

      styleSelected:function (feature: GritFeature<InterferenceTestDeviceModel>, resolution) {
        let icon = new Style({
          image: new Icon({scale: 0.2, color: 'blue', src: "/assets/img/grit/device/spoofer.svg",}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });

        let stroke = new Style({
          stroke: new Stroke({ color: [0,0,255, 0.1], width: 2 }),
          fill: new Fill({color:[0,0,255, 0.1] }),
          geometry: feature.entity.maskGeometry,
        });
        return [icon, stroke];
      },
    })
  },
];

export const Receivers: Layer[] = [
  { id:'receiver',
    name:'Receiver',
    image:"/assets/img/grit/receiver/receiver.svg", //TODO Change Receiver SVG
    visible:true ,
    olLayer:new VectorLayerDMTR({
      source: new VectorSource(),
      style: new Style({
        image: new Icon({
          scale: 0.2,
          color: 'black',
          src: "/assets/img/grit/receiver/receiver.svg",
        }),
      }),
      styleSelected: new Style({
        image: new Icon({
          scale: 0.2,
          color: 'red',
          src: "/assets/img/grit/receiver/receiver.svg",
        }),
      }),
    })
  }];

export const InterferenceTest: Layer[] = [
  { id:'current',
    name:'Current',
    image:"/assets/img/grit/interference-test/draft.svg",
    visible:true,
    olLayer: new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: 'black', width: 2 }),
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/draft.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
      styleSelected:function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: '#129AD5', width: 2 })
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/draft-selected.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
    })
  },
  { id:'approval',
    name:'Approval',
    image:"/assets/img/grit/interference-test/approval.svg",
    visible:true ,
    olLayer:new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: '#DE9833FF', width: 2 }),
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/approval.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
      styleSelected:function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: '#129AD5', width: 2 })
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/approval-selected.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
    })
  },
  { id:'approved',
    name:'Approved',
    image:"/assets/img/grit/interference-test/approved.svg",
    visible:true ,
    olLayer:new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: 'green', width: 2 }),
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/approved.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
      styleSelected:function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: '#129AD5', width: 2 })
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/approved-selected.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
    })
  },
  { id:'executing',
    name:'Executing',
    image:"/assets/img/grit/interference-test/executing.svg",
    visible:true ,
    olLayer:new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: Feature, resolution) {

        let stroke = new Style({
          stroke: new Stroke({ color: '#004B75', width: 2 }),
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/executing.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
      styleSelected:function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: '#129AD5', width: 2 })
        });
        let icon = new Style({
          image: new Icon({scale: 0.2, src: "/assets/img/grit/interference-test/executing-selected.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
    })
  }];

export const Radar: Layer[] = [
  { id:'radar',
    name:'Radar',
    image:"/assets/img/grit/radar/radar2.svg",
    visible:true ,
    olLayer:new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: [0,0,0, 0.1], width: 2 }),
          fill: new Fill({color:[0,0,0, 0.1] })
        });
        let icon = new Style({
          image: new Icon({scale: 0.3, src: "/assets/img/grit/radar/radar2.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
      styleSelected:function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: [18,154,213, 0.2], width: 2 }),
          fill: new Fill({color:[18,154,213, 0.2] })
        });
        let icon = new Style({
          image: new Icon({scale: 0.3, src: "/assets/img/grit/radar/radar2-selected.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
    })
  },
  { id:'user_radar',
    name:'User Radar',
    image:"/assets/img/grit/radar/radar2-user.svg",
    visible:true ,
    olLayer: new VectorLayerDMTR({
      source: new VectorSource(),
      style: function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: [0,0,0, 0.1], width: 2 }),
          fill: new Fill({color:[0,0,0, 0.1] })
        });
        let icon = new Style({
          image: new Icon({scale: 0.3, src: "/assets/img/grit/radar/radar2-user.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
      styleSelected:function (feature: Feature, resolution) {
        let stroke = new Style({
          stroke: new Stroke({ color: [18,154,213, 0.2], width: 2 }),
          fill: new Fill({color:[18,154,213, 0.2] })
        });
        let icon = new Style({
          image: new Icon({scale: 0.3, src: "/assets/img/grit/radar/radar2-user-selected.svg"}),
          geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent()))
        });
        return [stroke, icon];
      },
    })
  }];
//endregion
